import includesCaseInsensitiveCheck from './includesCaseInsensitive';
import includesIfDefinedCheck from './includesIfDefined';

export default {
  includesCaseInsensitive: includesCaseInsensitiveCheck,
  includesIfDefined: includesIfDefinedCheck,
};
